import React from "react";
import { withTranslation } from "react-i18next";
import { Switch } from "antd";

function TelemetryVariantSwitch({ variant, onChange, style }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        ...style,
      }}
    >
      <span style={{ lineHeight: 1 }}>Vista completa</span>
      <Switch
        checked={variant === "reduced"}
        onChange={(checked) => onChange(checked ? "reduced" : "full")}
      />
      <span style={{ lineHeight: 1 }}>Vista reducida</span>
    </div>
  );
}

export default withTranslation()(TelemetryVariantSwitch);
